<template>
  <div class="layout-container">
    <nav-bar />
    <app-main />
    <app-footer />
  </div>
</template>

<script>
  import NavBar from './components/NavBar.vue'
  import AppMain from './components/AppMain.vue'
  import AppFooter from './components/AppFooter.vue'

  export default {
    components: { NavBar, AppMain, AppFooter },
  }
</script>

<style lang="scss" scoped>
  .layout-container {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding-top: 60px;
    background: #10151f;
    background-image: radial-gradient(
        ellipse 800px 420px at 15% -5%,
        rgba(252, 110, 62, 0.09),
        transparent
      ),
      radial-gradient(
        ellipse 900px 500px at 90% 0%,
        rgba(64, 128, 255, 0.08),
        transparent
      );
  }
</style>
